import React from 'react';
import { Popover } from '@mui/material';
import SharedDateCalendar from './SharedDateCalendar';

export const logDatePickerPaperSx = {
  mt: 1,
  borderRadius: '16px',
  boxShadow: '0 18px 40px rgba(15, 23, 42, 0.18)',
  overflow: 'hidden',
};

const LogDatePickerPopover = ({
  open,
  anchorEl,
  onClose,
  value,
  onChange,
  calendar: CalendarComponent = SharedDateCalendar,
  paperSx = {},
  ...calendarProps
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    PaperProps={{
      sx: {
        ...logDatePickerPaperSx,
        ...paperSx,
      },
    }}
  >
    <CalendarComponent
      value={value}
      onChange={onChange}
      {...calendarProps}
    />
  </Popover>
);

export default LogDatePickerPopover;
